module.exports = __webpack_public_path__ + "img/gyht.1204db30.svg";